module.exports = __webpack_public_path__ + "img/vessel-highlight-arrow.cd85f645.svg";